var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition",
    {
      attrs: { name: "md-ripple", appear: "" },
      on: { "after-enter": _vm.end },
    },
    [_vm.animating ? _c("span") : _vm._e()]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }